module.exports = __webpack_public_path__ + "img/ErgonomistLeahZhang-m.19ab00dd.png";